<template>
	<b-container fluid>
		<page-title><h2><router-link :to="{ name: 'DebtorList' }" class="nav-link">Dłużnicy</router-link>/Nowy dłużnik</h2></page-title>

		<div class="col page-element">
			<alert-loading v-if="loading"></alert-loading>
			<div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>

			<DebtorForm :handle-submit="create" :values="item" :errors="violations"></DebtorForm>
		</div>
	</b-container>
</template>

<script>
  import DebtorForm from './Form.vue';
  import { createNamespacedHelpers } from 'vuex';

  const { mapActions, mapGetters } = createNamespacedHelpers('debtor/create');

  export default {
    components: {
      DebtorForm
    },
    data: function() {
      return {
        item: {
          address: {}
		    }
      }
    },
    computed: mapGetters([
      'error',
      'loading',
      'created',
      'violations'
    ]),
    methods: {
      create: function(item) {
        this.$store.dispatch('debtor/create/create', item);
      }
    },
    watch: {
      created: function (created) {
        if (created) {
          this.$router.push({ name: 'DebtorUpdate', params: { id: created['@id']} });
        }
      }
    },
    created(){
      this.$store.dispatch('debtor/create/reset');
	}
  }
</script>



// WEBPACK FOOTER //
// Create.vue?0e6075aa